import {
	fetchGet,
	fetchPost,
	fetchJsonPost
} from "../plugins/http.js";

export const login = data => fetchJsonPost('/student/login', data)

export const matchLogin = data => fetchPost('/api/events/login', data)

export const getToken = () => fetchGet('v2/auth/token/issue', true)

export const getVideo = () => fetchGet('student/index');

export const getDefault = () => fetchGet('/api/v2/classroom/default')

export const getStatic = () => fetchGet('/student/statistics');

export const sendMsg = data => fetchJsonPost('/api/coursemsgs/create', data)

export const getProduct = data => fetchGet(`/pay/products/${data}`)

export const getJSSDK = data => fetchJsonPost('/school/jssdk', data, true)

export const createOrder = data => fetchJsonPost('/pay/order', data)

export const getPayCode = data => fetchGet(`/pay/create?order_sn=${data.order_sn}&client=${data.client}&pay_way=${data.pay_way}`)

export const getPayCodeWx = data => fetchGet(`/pay/create?order_sn=${data}&client=2`)

export const getPayStatus = data => fetchGet(`/pay/order/show?order_sn=${data}`)

export const getOrderStatus = data => fetchGet(`/pay/order/callback?order_sn=${data}`)

export const getUserInfo = () => fetchGet('/api/user')

export const uploadImg = () => fetchGet('/api/uploadsign/image')

export const uploadHomework = () => fetchGet('/api/uploadsign/homework')

export const updateUserInfo = data => fetchJsonPost('/api/user', data)

export const updateMobile = data => fetchJsonPost('/student/reset/mobile', data)

export const getCode = data => fetchJsonPost('/api/smscode', data)

export const blueTest = () => fetchGet('/testing/placement/index')

export const getLansiReport = data => fetchGet(`/testing/placement/show/${data}`)

export const updatePassword = data => fetchJsonPost('/student/reset/password', data)

export const getOrderList = () => fetchGet('/pay/order/list');

export const getQuestions = data => fetchPost('/testing/placement/questions', data)

export const submitResult = data => fetchPost('/testing/placement/commit', data)

export const getStatus = data => fetchGet(`/testing/placement/status/${data}`)

export const getBookCat = () => fetchGet('/api/greatcourses')

export const getBookList = data => fetchGet(`api/greatcourses/index/${data.id}?page=${data.page}&pagesize=${data.pagesize}`)

export const getSchedules = data => fetchGet(`/student/schedules?date=${data.date}&offset=${data.offset}`)

export const getSchedulesList = data => fetchGet(`/student/schedules/dates?start_at=${data.start_at}&end_at=${data.end_at}&offset=${data.offset}`)

export const register = data => fetchJsonPost('/api/register', data)

export const resetPassword = data => fetchJsonPost('/api/resetpassword', data)

export const getBookData = data => fetchGet(`/api/greatcourses/show/${data}`)

export const changeCourse = data => fetchGet(`/schedules/available/date/${data.id}?course_id=${data.courseId}&offset=${data.offset}`)

export const getAvailableTime = data => fetchGet(`/schedules/available/time/${data.id}?start_date=${data.date}&course_id=${data.courseId}&offset=${data.offset}`)

export const postRepairCourse = data => fetchJsonPost('/schedules/restudy', data)

export const postChangeCourse = data => fetchJsonPost('/schedules/change', data)

export const getEvaluate = data => fetchGet(`/student/schedule/feedback/${data}`)

export const evaluate = data => fetchPost('/student/schedule/feedback', data)

export const getCourseCenter = () => fetchGet('/api/smartcourses');

export const getCourseDetails = data => fetchGet(`/api/smartcourses/${data.id}?page=${data.page}&offset=${data.offset}&pagesize=${data.pagesize}`)

export const getSemesters = data => fetchGet(`/api/semesters?offset=${data}`)

export const getTeacherList = data => fetchGet(`/api/teachertimes/teachers/${data}`) 

export const getAvailableTeacher = data => fetchPost('/api/teachertimes/teacher', data)

export const submitFixTime = data => fetchPost('api/booktimes/create', data)

export const getBookFixTimeStatus = () => fetchGet('/api/booktimes/callback')

export const getTeacherTimes = data => fetchGet(`/api/teachertimes/times/${data.semesterId}/${data.teacherId}`)

export const getAvailableTeacherList = data => fetchGet(`/schedules/available/teachers?lesson_id=${data.id}&course_id=${data.courseId}`)

export const getAvailableTimeList = data => fetchGet(`/schedules/available/list?teacher_id=${data.teacherId}&course_id=${data.courseId}&offset=${data.offset}`)

export const submitNewSchedule = data => fetchPost('/schedules/new', data)

export const getSchedulesStatus = data => fetchGet(`/api/semesters?offset=${data}`)

export const cancelCourse = data => fetchJsonPost(`/schedules/cancel/${data.id}`, data.offset)

export const sumbitResult = data => fetchPost('student/booktestresults', data)

export const getTestReport = data => fetchGet(`/testing/report/${data}`)

export const getMoney = () => fetchGet('/student/money')

export const translation = data => fetchJsonPost('/student/translate', data)

export const getLessons = () => fetchGet('/student/lessons')

export const newAvailableSubmit = data => fetchPost('/student/schedules/new', data)

export const getHomeworkList = data => fetchGet(`/student/homeworks?level=${data.level}&page=${data.page}&pagesize=${data.pagesize}&offset=${data.offset}`)

export const getHomeworkDetails = data => fetchGet(`/student/homeworks/${data}`)

export const submitHomework = data => fetchPost('/student/homeworks', data)


// WEBPACK FOOTER //
// ./src/api/index.js